<template lang="html">
    <div>
        <div class="image-wrapper">
            <img v-if="user" :src="user.image_url" alt="">
            <input type="file" ref="image" style="display: none;" v-on:change="openUploadImage">
        </div>
        <div class="buttons">
            <UiButton class="nexyo-button"
                :name="($store.state.settings.steps[2].isLoading && type=='image') ? 'Procesare..' : 'Încarcă imagine'"
                @click="$refs.image.click()" 
            />
        </div>
        <div class="video-wrapper">
            <iframe v-if="user && user.video_url" id="specialist-video" :src="user.video_url" width="100%" height="100%" frameborder="0" scrolling="no" allowfullscreen="true"></iframe>
            <input type="file" ref="video" style="display: none;" v-on:change="openUploadVideo">
        </div>
        <div class="buttons">
            <UiButton 
                class="nexyo-button" 
                :name="($store.state.settings.steps[2].isLoading && type=='video') ? 'Procesare..' : 'Încarcă video de prezentare'"
                @click="$refs.video.click()"
            />
        </div>
    </div>
</template>

<script>
    import UiInput from '@/components/ui/Input'
    import UiButton from '@/components/ui/Button'
    import {
        mapActions,
        mapGetters
    } from 'vuex'

    export default {
        components: {
            UiInput,
            UiButton
        },
        data() {
            return {
                interval: null,
                type: null
            };
        },
        mounted() {
            this.interval = setInterval(() => {
                this.validateStep();
            }, 1000);
        },
        computed: {
            ...mapGetters({
                user: 'user/user',
                thirdStep: 'settings/thirdStep'
            })
        },
        watch: {
            '$store.state.user.user.video_url': {
                handler(newVal) {
                    if (newVal) {
                        console.log(video);
                        let video = document.getElementById('specialist-video');
                        if(video) 
                            video.load();
                    }
                    this.type = null;
                },
                immediate: true
            }
        },
        methods: {
            ...mapActions({
                updateImage: 'settings/updateImage',
                updateVideo: 'settings/updateVideo'
            }),
            openUploadImage() {
                this.$store.state.settings.steps[2].isLoading = true;
                this.type = 'image';
                this.updateImage(this.$refs.image.files[0]);
            },
            openUploadVideo() {
                this.$store.state.settings.steps[2].isLoading = true;
                this.type = 'video';
                this.updateVideo(this.$refs.video.files[0]);
            },
            validateStep() {
                if (this.thirdStep.image_url || this.$store.state.user.user.image_url) {
                    this.$emit('activeButton', true);
                    clearInterval(this.interval);
                } else {
                    this.$emit('activeButton', false);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .image-wrapper,
    .video-wrapper {
        overflow: hidden;
        margin: 20px auto 0px auto;
        display: flex;
        justify-content: center;

        img,
        video {
            user-select: none;
            -webkit-user-drag: none;
        }
    }

    .image-wrapper {
        min-width: 245px;
        min-height: 325px;
        width: 245px;
        height: 325px;
    }

    .video-wrapper {
        margin-top: 40px;
        max-width: 400px;
        width: calc(100% - 40px);
        max-height: 400px;


        video {
            width: 100%;
            height: auto;
        }

        iframe {
            min-height: 250px;
        }
    }

    .buttons {
        width: 100% !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nexyo-button {
        margin: 20px;
    }

    @media only screen and (max-width: 1000px) {
        .buttons {
            flex-direction: column;
        }

        .nexyo-button {
            margin: 10px auto;
        }
    }
</style>